import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Rating from '../items/Rating';
import ImageHelper from '../../helpers/ImageHelper';
import AnalyticsService from '../../services/AnalyticsService';
import CONSTANTS from '../../constants';
import placeholderImage from '../../assets/images/placeholder-bg.png';
import lazyLoad from '../../assets/js/lazy-load';
import CartService from '../../services/CartService';
import OptionHelper from '../../helpers/OptionHelper';
import { updateCart } from '../../actions/Cart';

class PopularItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      options: [],
      errors: [],
      quantity: 1,
      comment: ''
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState({
      showModal: !this.state.showModal
    });
  }

  showItemDetails(item) {
    this.props.history.push(
      `${CONSTANTS.BASE_URL}${this.props._location.slug}/menu/${item.menu_id}`
    );
  }

  isChecked(item) {
    return (
      this.props.selectedItems &&
      !!this.props.selectedItems.find((i) => parseInt(item.menu_id, 10) === parseInt(i.menu_id, 10))
    );
  }

  componentDidUpdate() {
    let banners = document.querySelectorAll('.lazy-bg');
    if (banners.length > 0) lazyLoad(banners, { background: true });
  }

  addOptionsAndGoBack() {
    let validationErrors = OptionHelper.validationErrors(this.state.options, this.state.options);
    if (validationErrors && validationErrors.length > 0) {
      this.setState({ errors: validationErrors });
      return this.scrollToFirstError(validationErrors[0]);
    }
    CartService.addItem(
      { ...this.props.item, options: this.state.options, comment: this.state.comment },
      this.state.quantity
    );
    this.props.updateCart();
    this.toggleModal();
  }
  firebaseEvent(eventName) {
    let item = this.props.item;
    let locationId = this.props._location.locationId;
    AnalyticsService.logEvent(eventName, {
      category: CONSTANTS.EVENTS.ITEM.GROUP_NAME,
      locationId,
      itemId: item.menu_id
    });
  }

  increment() {
    this.setState({ quantity: this.state.quantity + 1 });
  }

  decrement() {
    if (this.state.quantity > 1) {
      this.setState({ quantity: this.state.quantity - 1 });
    }
  }

  render() {
    let { item, categories } = this.props;
    let category = categories.find((category) => category.category_id === item.menu_category_id);
    if (item && categories) {
      return (
        <React.Fragment>
          <div
            style={{
              background: `-webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0.8) 115%), url('${placeholderImage}')`
            }}
            className="popular-image lazy-bg"
            data-background={`-webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0.8) 115%),`}
            data-url={ImageHelper.getImageURL(item.menu_photo, '?func=bound&w=230&h=165')}
            onClick={this.props.onItemClick}
          >
            <div className="opaque">
              <div className="f3 popular-item-name">{item.menu_name}</div>
              <Rating item={item} text={category.name} settings={this.props.locationSettings} />
            </div>
          </div>
        </React.Fragment>
      );
    }
    return '';
  }
}

function mapStateToProps(state) {
  const { popularItems, categories, location, locationSettings } = state;
  return { popularItems, categories, _location: location, locationSettings };
}
export default withRouter(connect(mapStateToProps, { updateCart })(PopularItem));
